import { useRef, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';

import { Loader } from '@components';
import { businessesQuery, businessMutation } from '@queries';
import { ButtonSpinnerDarkIcon, LayersIcon, MoreHorizontalIcon } from '@svgs';

const Business = ({ business }) => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  // menu activation
  const dropdownMenu = useRef(null);
  const [showDropdownMenu, setShowDropdownMenu] = useState(false);
  const closeOpenMenus = (e) => {
    if (showDropdownMenu && !dropdownMenu.current?.contains(e.target)) {
      setShowDropdownMenu(false);
    }
  };
  document.addEventListener('mousedown', closeOpenMenus);

  // save user
  const mutation = useMutation(
    businessMutation(business.id, {
      onSuccess: (data) => {
        // invalidate user lists and detail
        queryClient.invalidateQueries({
          queryKey: ['businesses', 'detail', business.id],
        });
        queryClient.invalidateQueries({ queryKey: ['businesses', 'list'] });
        navigate(`/dashboard/projects/${business.id}`);
      },
    }),
  );

  return (
    <div className="sb-row-item">
      <div>
        <p>Project</p>
      </div>
      <div>
        <p>
          {business.deleted && <>{business.business_name}</>}
          {!business.deleted && (
            <Link to={`/dashboard/projects/${business.id}`}>
              {business.business_name}
            </Link>
          )}
        </p>
      </div>
      <div>{business.primary_domain}</div>
      {business.deleted && (
        <div className="sb-options">
          {mutation.isPending && <ButtonSpinnerDarkIcon />}
          {!mutation.isPending && (
            <>
              <button
                className="sb-page-options-menu-trigger sb-options-trigger"
                onClick={() => setShowDropdownMenu(!showDropdownMenu)}
              >
                <MoreHorizontalIcon />
              </button>
              <div
                ref={dropdownMenu}
                className={
                  'sb-options-menu ' +
                  (showDropdownMenu ? 'sb-show' : 'sb-hide')
                }
              >
                <div className="sb-options-menu-content">
                  <button
                    type="button"
                    className="sb-options-item"
                    onClick={() => mutation.mutate({ deleted: false })}
                  >
                    <LayersIcon />
                    {t('Re-activate project')}
                  </button>
                </div>
              </div>
            </>
          )}
        </div>
      )}
    </div>
  );
};

export const SearchProjects = ({ searchDisabled = false, searchTerm }) => {
  // Fetch businesss
  const {
    data: businesssData,
    isPending: businesssIsPending,
    isError,
  } = useQuery(
    businessesQuery({
      q: searchTerm,
      deleted: searchDisabled ? 1 : 0,
      limit: 100,
      order_by: 'business_name',
    }),
  );

  return (
    <>
      {businesssIsPending && <Loader className="sb-loader sb-loader-block" />}
      {!businesssIsPending && businesssData.objects.length === 0 && (
        <p>No projects found</p>
      )}
      {!businesssIsPending && businesssData.objects.length > 0 && (
        <>
          <div className="sb-content-view-row">
            {businesssData.objects.map((business) => {
              return <Business key={business.id} business={business} />;
            })}
          </div>
        </>
      )}
    </>
  );
};
